// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_i5-0";
export var fulfillmentPanelBody = "_i5-1";